

@if(lazyLoading){
    <app-header></app-header>
    <main>
        <div class="lazyloading">
            <img [src]="imageBaseUrl + 'loading.svg'" alt="Loading" />
        </div>
    </main>

} @else {
    <app-header></app-header>
    <main>
        <router-outlet></router-outlet>
        <app-terms></app-terms>
    </main>

    <app-footer></app-footer>
}

